

import React, { memo, useMemo } from 'react';
import { Button } from '../../../ui-kit';
import { getSocialAuthButtonPropsByType } from '../utils/socialAuthButtonFactory';






const SocialAuthButton = (props) => {
  const {
    type,
    onClick
  } = props;

  const propsByType = useMemo(() => getSocialAuthButtonPropsByType(type), [type]);

  return (
    <Button
      {...propsByType}
      className="social-auth-button"
      isFullWidth
      prefixSize={24}
      onClick={onClick} />);


};

export default memo(SocialAuthButton);